import { render, staticRenderFns } from "./audit-dialog.vue?vue&type=template&id=56977004&"
import script from "./audit-dialog.vue?vue&type=script&lang=ts&"
export * from "./audit-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports